// Vanilla CSS for the box primitives (SelectionBox, SelectionCheckbox).
// Prefix: sbx-. Aggregated into libraryStyles.
export const boxStyles = `
  .sbx-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem 1rem;
    flex-wrap: wrap;
    text-align: center;
  }
  .sbx-item {
    border-width: 2px;
    border-style: solid;
    border-radius: var(--rad-catchup-xlarge);
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    cursor: pointer;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .sbx-px-8 { padding-left: 2rem; padding-right: 2rem; }
  .sbx-px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
  .sbx-item-selected { border-color: var(--catchup-blue-400); }
  .sbx-item-unselected { border-color: var(--catchup-gray-100); }
  .sbx-item-unselected:hover { border-color: var(--catchup-blue-500); }
  .sbx-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
  }
  .sbx-dim { opacity: 0.5; }
  .sbx-text {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .sbx-body { flex: 1 1 0%; }
  .sbx-subtext { font-size: var(--fs-md); }
`;
